export default __webpack_public_path__ + "static/media/mak.bbc034ec.svg";